import { IndexTypeDTO, RoadmapPortfolioDetailsDisplayLabelsYearDTO } from 'csr-asset-app';

export const NO_ROADMAP_LABELS: { [key: string]: RoadmapPortfolioDetailsDisplayLabelsYearDTO } = {
  '2020': {
    perLabelGroup: {
      EPC: [
        {
          label: {
            label: 'D',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        },
        {
          label: {
            label: 'F',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        }
      ]
    }
  },
  '2021': {
    perLabelGroup: {
      EPC: [
        {
          label: {
            label: 'D',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        },
        {
          label: {
            label: 'F',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        }
      ]
    }
  },
  '2022': {
    perLabelGroup: {
      EPC: [
        {
          label: {
            label: 'D',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        },
        {
          label: {
            label: 'E',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        }
      ]
    }
  },
  '2023': {
    perLabelGroup: {
      EPC: [
        {
          label: {
            label: 'D',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        },
        {
          label: {
            label: 'E',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        }
      ]
    }
  },
  '2024': {
    perLabelGroup: {
      EPC: [
        {
          label: {
            label: 'D',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        },
        {
          label: {
            label: 'E',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        }
      ]
    }
  },
  '2025': {
    perLabelGroup: {
      EPC: [
        {
          label: {
            label: 'D',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        },
        {
          label: {
            label: 'E',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        }
      ]
    }
  },
  '2026': {
    perLabelGroup: {
      EPC: [
        {
          label: {
            label: 'D',
            indexType: IndexTypeDTO.EPC
          },
          total: 2
        }
      ]
    }
  },
  '2027': {
    perLabelGroup: {
      EPC: [
        {
          label: {
            label: 'C',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        },
        {
          label: {
            label: 'D',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        }
      ]
    }
  },
  '2028': {
    perLabelGroup: {
      EPC: [
        {
          label: {
            label: 'C',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        },
        {
          label: {
            label: 'D',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        }
      ]
    }
  },
  '2029': {
    perLabelGroup: {
      EPC: [
        {
          label: {
            label: 'C',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        },
        {
          label: {
            label: 'D',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        }
      ]
    }
  },
  '2030': {
    perLabelGroup: {
      EPC: [
        {
          label: {
            label: 'C',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        },
        {
          label: {
            label: 'D',
            indexType: IndexTypeDTO.EPC
          },
          total: 1
        }
      ]
    }
  }
};
